/*
 * Shop identity and visibility are read from the Influencer the dashboard has
 * already loaded rather than fetched again. Every field below has a getter on
 * the domain object with matching semantics — isOpen is !sold_out, isSearchable
 * is !not_searchable — and its products list is the same set the server was
 * counting: non-archived, inactive included.
 */

const SHOP_TYPES = [
  ["isGroupShop", "collection"],
  ["isAgentShop", "agent"],
  ["isTcShop", "talent_coordinator"],
];

// is_auto_collection has no getter on the client; a group shop is the collection
// signal here.
export const shopType = (influencer) =>
  SHOP_TYPES.find(([flag]) => influencer[flag])?.[1] ?? "talent";

export const shopIdentity = (influencer) => ({
  influencerId: influencer.influencerId,
  name: influencer.name,
  route: influencer.route,
  type: shopType(influencer),
  completionDeadline: influencer.completionDeadline,
  fulfillmentSpeed: influencer.fulfillmentSpeed,
  created: influencer.created,
});

export const visibility = (influencer) => {
  const products = influencer.products ?? [];

  return {
    isOpen: influencer.isOpen,
    isHidden: influencer.isHidden,
    isSearchable: influencer.isSearchable,
    isLive: influencer.isLive,
    activeProductCount: products.filter((product) => product.isActive).length,
    totalProductCount: products.length,
  };
};

export default { shopIdentity, shopType, visibility };
